import * as React from 'react';
import AvatarImage from './image';
import { Container, AvatarLink, IdentityIndicator } from './style';
import ConditionalWrap from 'src/components/conditionalWrap';
import InitialsAvatar from './initialsAvatar';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

class Avatar extends React.Component {
  renderIdentity(member) {
    if (member.isExpert) {
      return <VerifiedUserIcon />;
    }

    if (member.isChair) {
      return <EventSeatIcon />;
    }

    return null;
  }
  render() {
    const {
      source,
      size = 32,
      isClickable = false,
      mobilesize,
      style,
      member,
      fontSize,
      className,
    } = this.props;
    return (
      <Container
        size={size}
        className={className}
        mobilesize={mobilesize}
        style={style}
        type={'community'}
      >
        {source ? (
          <ConditionalWrap
            condition={isClickable}
            wrap={children => <AvatarLink to={`/`}>{children}</AvatarLink>}
          >
            <AvatarImage
              src={source}
              size={size}
              mobilesize={mobilesize}
              type={'community'}
              alt={'community.name'}
            />
            {member ? this.renderIdentity(member) : null}
            {/* {identity ? <IdentityIndicator src={identity} /> : null} */}
          </ConditionalWrap>
        ) : (
          <InitialsAvatar member={member} size={size} fontSize={fontSize} />
        )}
      </Container>
    );
  }
}

class AvatarHandler extends React.Component {
  render() {
    return <Avatar {...this.props} />;
  }
}

export default AvatarHandler;
